export default {
  costumers: [],
  costumer: null,
  error: false,
  errorMessage: "",
  success: false,
  successMessage: "",
  pagination: {},
};
